import { Navigate, Outlet } from 'react-router';
import { usePermissions } from '@/hooks/usePermissions';

type Props = { featureKey: string; staffOnly?: never } | { staffOnly: true; featureKey?: never };

export function PermissionGuard({ featureKey, staffOnly }: Props) {
  const { can, isStaff } = usePermissions();

  const allowed = staffOnly ? isStaff : can(featureKey);

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
